import styled from 'styled-components';

export const ContainerFilter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContainerButtons = styled.div`
  display: flex;
  gap: 10px;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 32px 60px;
  gap: 16px;
  width: 90vw;
`;
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;